// Tipos de documento de identidad - Colombia
export const TIPOS_IDENTIFICACIONES = [
  { value: "CC", text: "Cédula de Ciudadanía" },
  { value: "TI", text: "Tarjeta de identidad" },
  { value: "CE", text: "Cédula de Extranjería" },
  { value: "PS", text: "Pasaporte" },
  { value: "RC", text: "Registro civil" },
  { value: "NUIP", text: "Número único de identificación personal" },
  { value: "OT", text: "Otro" },
];

// Tipo de póliza (Colombia)
export const TIPOS_PLAN_GENERAL = [
  { value: "VG", text: "Vida Grupo" },
  { value: "VD", text: "Vida Grupo Deudores" },
  { value: "AP", text: "Accidentes Personales" },
];

// Procedimiento (Colombia)
export const TIPOS_PROCEDIMIENTO = [
  { value: "INCLUSION", text: "Inclusión" },
  { value: "AUMENTO", text: "Aumento valor asegurado" },
  { value: "ACTUALIZACION", text: "Actualización de datos" },
];

export const TIPOS_BENEFICIARIOS = [
  { value: "ESPOSA(O)", text: "Conyuge" },
  { value: "HIJA(O)", text: "Hijo" },
  { value: "HERMANA(O)", text: "Hermano" },
  { value: "MADRE", text: "Madre" },
  { value: "PADRE", text: "Padre" },
  { value: "OTROS", text: "Otros" },
];

export const TIPOS_SEXO = [
  { value: "M", text: "Masculino" },
  { value: "F", text: "Femenino" },
];

export const TIPOS_SINO = [
  { value: "S", text: "Sí" },
  { value: "N", text: "No" },
];
